import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HmsService, ChemicalPublicDto } from 'src/app/services/hms.service';
import { AppSettings } from 'src/app/shared/app-settings';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-chemical-public-view',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './chemical-public-view.component.html',
  styleUrls: ['./chemical-public-view.component.scss']
})
export class ChemicalPublicViewComponent implements OnInit {
  chemical: ChemicalPublicDto | null = null;
  loading = true;
  error = false;
  companyLogo: string = '/assets/customers/default/logo.png';

  constructor(
    private route: ActivatedRoute,
    private hmsService: HmsService,
    private translateService: TranslateService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.loadCompanyLogo();

    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.loading = false;
      this.error = true;
      return;
    }

    this.hmsService.getChemicalByShareToken(token).subscribe({
      next: (response) => {
        if (response?.success && response.result) {
          this.chemical = response.result;
        } else {
          this.error = true;
        }
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }

  private loadCompanyLogo(): void {
    try {
      const details = JSON.parse(localStorage.getItem(AppSettings.StorageKeys.DomainDetails) || 'null');
      if (details?.userLogo) {
        this.companyLogo = details.userLogo;
      } else {
        const domain = this.configService.get('domain');
        if (domain) {
          this.companyLogo = `/assets/customers/${domain}/logo.png`;
        }
      }
    } catch {
      // Keep default logo
    }
  }

  parseList(json?: string): string[] {
    if (!json) return [];
    try { return JSON.parse(json); } catch { return []; }
  }

  downloadSds(): void {
    if (this.chemical?.sdsDownloadUrl) {
      window.open(this.chemical.sdsDownloadUrl, '_blank');
    } else if (this.chemical?.sdsExternalUrl) {
      window.open(this.chemical.sdsExternalUrl, '_blank');
    }
  }

  getSdsUrl(): string | null {
    return this.chemical?.sdsDownloadUrl || this.chemical?.sdsExternalUrl || null;
  }
}
